
// import auth from "../services/authService";
import { logout } from "../services/authService";
import { Component } from 'react';

class Logout extends Component {

    async componentDidMount() {
        await logout();
        window.location = "/login";
    }
    render() {
        return null;
    }
}

export default Logout;